import React, { useState, useRef } from 'react';

interface ImageMagnifierProps {
  src: string;
  alt?: string;
  zoomLevel?: number;
  width?: number;
  height?: number;
  className?: string;
}

const ImageMagnifier: React.FC<ImageMagnifierProps> = ({
  src,
  alt = "放大图片",
  zoomLevel = 2,
  width = 400,
  height = 300,
  className = ""
}) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [showMagnifier, setShowMagnifier] = useState(false);
  const [imgSize, setImgSize] = useState({ width: 0, height: 0 });
  const containerRef = useRef<HTMLDivElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);

  const handleMouseEnter = () => {
    if (imgRef.current) {
      const { width, height } = imgRef.current.getBoundingClientRect();
      setImgSize({ width, height });
    }
    setShowMagnifier(true);
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!containerRef.current || !imgRef.current) return;

    const imgRect = imgRef.current.getBoundingClientRect();

    // 计算鼠标相对于图片的位置 (百分比)
    const x = ((e.clientX - imgRect.left) / imgRect.width) * 100;
    const y = ((e.clientY - imgRect.top) / imgRect.height) * 100;

    // 确保百分比在0-100之间
    const boundedX = Math.max(0, Math.min(100, x));
    const boundedY = Math.max(0, Math.min(100, y));

    setPosition({ x: boundedX, y: boundedY });
  };

  const handleMouseLeave = () => {
    setShowMagnifier(false);
  };

  return (
    <div
      ref={containerRef}
      className={`relative overflow-hidden mx-auto ${className}`}
      style={{ width, height }}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      {/* 原始图片 */}
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
      />

      {/* 放大层完全覆盖 */}
      {showMagnifier && (
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url(${src})`,
            backgroundSize: `${imgSize.width * zoomLevel}px ${imgSize.height * zoomLevel}px`,
            backgroundPosition: `${-(position.x / 100) * (imgSize.width * zoomLevel - imgSize.width)}px ${-(position.y / 100) * (imgSize.height * zoomLevel - imgSize.height)}px`,
            backgroundRepeat: 'no-repeat', 
            zIndex: 10,
          }}
        />
      )}
    </div>
  );
};

export default ImageMagnifier;
